import { Stack, Text } from '@mantine/core';

import { ru } from '../i18n/ru';

/**
 * Словесный знак вместо картинки: повторяет начертание заголовка на сайте
 * коллектива (Raleway 600, верхний регистр, разрядка) и не тянет за собой
 * файл логотипа. Готовый логотип можно подставить сюда одним компонентом.
 */
export function Logo() {
  return (
    <Stack gap={1}>
      <Text className="wordmark" fz={18} c="graphite.9">
        {ru.app.title}
      </Text>
      {/* В шапке узкого экрана подпись не помещается и растягивала бы
          страницу по горизонтали, поэтому там её скрываем. */}
      <Text className="wordmark-sub" fz={8.5} c="graphite.5" visibleFrom="xs">
        {ru.app.subtitle}
      </Text>
    </Stack>
  );
}
